import { ProjectResponse } from "./api/projectsResponse.class";

export class ProjectInformationModalEntries {
    contractorName: string;
    projectName: string;
    projectNumber: string;
    projectDescription: string;
    shipVolume: string;
    shipType: string;
    shipName: string;

    constructor(p?: ProjectInformationModalEntries) {
        this.contractorName = p?.contractorName ?? '';
        this.projectName = p?.projectName ?? '';
        this.projectNumber = p?.projectNumber ?? '';
        this.projectDescription = p?.projectDescription ?? '';
        this.shipVolume = p?.shipVolume ?? '';
        this.shipType = p?.shipType ?? '';
        this.shipName = p?.shipName ?? '';
    }

    fillValues(projectData: ProjectResponse, projectId: number, shipId: number): ProjectInformationModalEntries {
        const project = projectData.getProjectById(projectId);
    
        if (!project) return this;
    
        const ship = projectData?.getShipById(shipId ?? -1);
        
        if (ship) {
          this.shipVolume = `${ship.maximumVolume} m³`;
          this.shipType = ship.type;
          this.shipName = ship.name;
        }
        
        this.contractorName = projectData.getContractorById(project.contractorId ?? -1)?.name ?? '';
        this.projectNumber = project.number ?? '';
        this.projectDescription = project.description ?? '';
        this.projectName = project.name ?? '';        
        return this;
    }
}